import { get } from '../index.ts'
import { Environment } from '../../environment.ts'
import type { SystemMessages } from '../../Generated/SystemMessages.ts'
import type { Observable } from 'rxjs'

export const loadSystemMessages: (all: boolean) => Observable<SystemMessages[]> = (all: boolean) => {
  return get(`${Environment.API_URL}/system-messages${all ? '?all=true' : ''}`)
}
